import React from 'react';
import { Align, Rotate, Toggler } from "@baseTypes/baseType";
import Legend, { LegendRow } from "../Legend/Legend";
import { LineLabel } from "@pages/dashboard/works/detalization/dynamics";
import FlexLine from "../flexLine/FlexLine";
import * as Highcharts from "highcharts";
import colors from "@infobis/ui-styles-utils/colors";

type PlanFactLegendProps = {
    align?: Align
    chartApi?: Highcharts.Chart
    additionalRows?: LegendRow[]
    planName?: string
    factName?: string
    unselectable?: boolean
    style?: React.CSSProperties
    padding?: { left?: number, right?: number }
}

const PlanFactLegend = (props: PlanFactLegendProps) => {
    const {
        align = Align.End,
        chartApi,
        additionalRows = [],
        planName = 'План',
        factName = 'Факт',
        unselectable = false,
        style,
        padding
    } = props;


    return (
        <FlexLine align={align} style={{ ...style, paddingLeft: padding?.left, paddingRight: padding?.right }}>
            <Legend rotate={Rotate.Row}
                    chartApi={chartApi}
                    toggler={Toggler.series}
                    unselectable={unselectable}
                    rows={[
                        {
                            id: 'plan',
                            color: colors.ELEMENTS_CHARTS_13,
                            values: [
                                <LineLabel color={colors.ELEMENTS_CHARTS_13} name={planName}></LineLabel>
                            ]
                        },
                        {
                            id: 'fact',
                            color: colors.ELEMENTS_CHARTS_15,
                            values: [
                                <LineLabel color={colors.ELEMENTS_CHARTS_15} name={factName}></LineLabel>
                            ]
                        },
                        ...additionalRows
                    ]}
            />
        </FlexLine>
    )
}

export default PlanFactLegend;